import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { Link, useNavigate } from "react-router-dom";
import authService from "../../services/auth.service";
// import { sendEmailVerification } from "firebase/auth";
import { toast } from "react-hot-toast";
import { auth } from "../../firebase.config";

// import useAuth from "../../hooks/useAuth";

const emailSchema = z.object({
  email: z.string().email("Please enter a valid email address"),
});

export default function EmailVerification() {
  const navigate = useNavigate();
  const user = auth.currentUser;

  // const { user } = useAuth();

  const [isSending, setIsSending] = useState(false);
  useEffect(() => {
    if (user && user.emailVerified) {
      navigate("/disclaimer");
    }
  }, []);

  const handleResend = async () => {
    console.log("user", user)

    if (user && !user.emailVerified) {
      try {
        setIsSending(true);
        await authService.sendVerificationEmail(user.email);
        toast.success("Verification email sent! Check your inbox.");
      } catch (error) {
        let msg = "Failed to resend email. Please try again."
        if (error.code === "auth/too-many-requests") {
          msg = "Too many attempts. Please wait a few minutes before trying again.";
        }
        console.error("Error resending email:", error);
        toast.error(msg);
      } finally {
        setIsSending(false);
      }
    } else {
      toast.success("Your email is already verified or you're not logged in.");
    }
  };

  return (
    <div className="flex items-center justify-center px-6 py-24">
      <div className="bg-white border border-black shadow-2xl rounded-xl p-8 w-full max-w-md text-center">
        {/* Icon */}
        <div className="w-16 h-16 mx-auto mb-4 bg-black rounded-full flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="#FFFFFF"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect width={20} height={16} x={2} y={4} rx={2} />
            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
          </svg>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-[#281D1BB2] mb-2">
          Verify your Email
        </h1>
        <p className="text-sm text-gray-600 mb-6">
          We have sent a verification email to your inbox. Click the link in the email to verify your account.
        </p>

          <button
            type="submit"
            disabled={isSending}
            onClick={handleResend}
            className="w-full py-2 bg-black text-white rounded-md transition hover:opacity-80 disabled:opacity-70"
          >
            {isSending ? "Resend Email" : "Resend Verification Email"}
          </button>

        <Link className="block mt-4" to="/login">
          <button className="w-full py-2 text-[#281D1BB2] rounded-md transition hover:underline">
            Back to Login
          </button>
        </Link>

        {/* Footer Note */}
        <p className="text-xs text-gray-400 mt-6">
          Didn't receive the email? Check your spam folder or try resending.
        </p>
      </div>
    </div>
  );
}